var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Column, CreateDateColumn, Entity, Index, PrimaryGeneratedColumn, Unique, UpdateDateColumn } from 'typeorm';
let TransactionIndex = class TransactionIndex {
    id;
    msafeAddress;
    digest;
    sequenceNumber;
    txType; // Transaction type - E.g. assets
    txSubType; // Transaction subType - E.g. coin_transfer
    isSendTx;
    isRejectTx;
    status; // History transaction status - E.g. Executed, Failed, Rejected
    updatedAt;
    createdAt;
    executedAt;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], TransactionIndex.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], TransactionIndex.prototype, "msafeAddress", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], TransactionIndex.prototype, "digest", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], TransactionIndex.prototype, "sequenceNumber", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], TransactionIndex.prototype, "txType", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], TransactionIndex.prototype, "txSubType", void 0);
__decorate([
    Column(),
    __metadata("design:type", Boolean)
], TransactionIndex.prototype, "isSendTx", void 0);
__decorate([
    Column(),
    __metadata("design:type", Boolean)
], TransactionIndex.prototype, "isRejectTx", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], TransactionIndex.prototype, "status", void 0);
__decorate([
    UpdateDateColumn(),
    __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], TransactionIndex.prototype, "updatedAt", void 0);
__decorate([
    CreateDateColumn(),
    __metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], TransactionIndex.prototype, "createdAt", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], TransactionIndex.prototype, "executedAt", void 0);
TransactionIndex = __decorate([
    Entity({ name: 'transaction_index' }),
    Index(['msafeAddress', 'txType', 'txSubType']),
    Unique(['msafeAddress', 'digest'])
], TransactionIndex);
export { TransactionIndex };
//# sourceMappingURL=module.js.map